import * as React from 'react'
import { useSelector } from 'react-redux'
import { getActiveAccountSlug } from 'auth/selectors'
import './styles.scss'
import { useTranslation } from 'translations'

function PosTerminals() {
    const { t } = useTranslation()
    const accountSlug = useSelector(getActiveAccountSlug)

    return (
        <div className="pos-iframe-wrapper">
            <iframe
                src={`https://convious.com/embed/pos${
                    accountSlug ? `?account=${encodeURIComponent(accountSlug)}` : ''
                }`}
                title={t('pos.iframeTitle')}
            />
        </div>
    )
}

export default PosTerminals
